import { useEffect, useState } from "react";
import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, MenuItem, Stack, TextField } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CheckIcon from "@mui/icons-material/Check";
import { useLanguage } from "../i18n/LanguageContext";

const empty = { username: "", password: "", name: "", role: "recepcionista" };

export default function UserDialog({ open, initial, onClose, onSave }) {
  const { t } = useLanguage();
  const [form, setForm] = useState(initial || empty);
  const [error, setError] = useState("");
  const [saving, setSaving] = useState(false);

  // (Mismo fix que en OccupantDialog: era useState(fn, deps) por error,
  // lo cual nunca reiniciaba el formulario entre aperturas.)
  useEffect(() => {
    if (open) setForm(initial ? { ...initial, password: "" } : empty);
  }, [initial, open]);

  const set = (k) => (e) => setForm((f) => ({ ...f, [k]: e.target.value }));

  const handleSubmit = async () => {
    if (!form.username.trim() || !form.name.trim() || (!initial && !form.password.trim())) {
      setError(t("userDialog.missingFields"));
      return;
    }
    setSaving(true);
    setError("");
    try {
      await onSave(form);
    } catch (err) {
      setError(err.response?.data?.error || t("userDialog.saveError"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
        {initial ? t("userDialog.titleEdit") : t("userDialog.titleAdd")}
        <IconButton onClick={onClose} size="small">
          <CloseIcon fontSize="small" />
        </IconButton>
      </DialogTitle>
      <DialogContent dividers>
        <Stack spacing={2}>
          <TextField label={t("userDialog.fullName")} value={form.name} onChange={set("name")} fullWidth />
          <TextField label={t("userDialog.username")} value={form.username} onChange={set("username")} fullWidth disabled={!!initial} />
          <TextField
            label={initial ? t("userDialog.passwordNew") : t("userDialog.password")}
            value={form.password}
            onChange={set("password")}
            fullWidth
          />
          <TextField select label={t("userDialog.role")} value={form.role} onChange={set("role")} fullWidth>
            <MenuItem value="recepcionista">{t("userDialog.roleRecepcionista")}</MenuItem>
            <MenuItem value="admin">{t("userDialog.roleAdmin")}</MenuItem>
          </TextField>
        </Stack>
        {error && (
          <Alert severity="error" sx={{ mt: 2 }}>
            {error}
          </Alert>
        )}
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose}>{t("common.cancel")}</Button>
        <Button variant="contained" startIcon={<CheckIcon />} onClick={handleSubmit} disabled={saving}>
          {saving ? t("common.saving") : t("common.save")}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
